module.exports = __webpack_public_path__ + "img/xzapp.5d5464aa.png";